module.exports = __webpack_public_path__ + "static/media/glasmachine.e514a8de.png";